import WechatApi from 'api/WechatApi';

// 获取微信收获地址所需配置
const getWxLocation = function (cb) {
  WechatApi.getWechatConfig({
    url: location.href.split('#')[0]
  }).then(res => {
    wx.config({
      debug: false,
      appId: res.data.appId,
      timestamp: res.data.timestamp,
      nonceStr: res.data.nonceStr,
      signature: res.data.signature,
      jsApiList: ['checkJsApi', 'openAddress']
    });
    wx.ready(function () {
      wx.checkJsApi({
        jsApiList: [
          'openAddress',
        ],
        success: function (res) {
          console.log(res);
        }
      });
      wx.openAddress({
        trigger: function (res) {
          console.log(res);
        },
        success: function (res) {
          cb(res);
        },
        cancel: function (res) {
          console.log(JSON.stringify(res));
        },
        fail: function (res) {
          console.log(res);
        }
      });
    });
    wx.error(function (res) {
      console.log(res);
    });
  }).catch(function (error) {
    console.log(error);
  });
}
export {
  getWxLocation
};